import { Routes } from '@angular/router';
import {
  faBadgeDollar,
  faBallotCheck,
  faUserCirclePlus,
  faGavel,
  faMessageDollar,
} from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const AUCTION_ITEMS: NavItem[] = [
  {
    label: 'Remates',
    icon: faBadgeDollar,
    iconSet: 'duo',
    roles: ['auction'],
    children: [
      {
        label: 'Seleccionar Vehículos',
        icon: faBallotCheck,
        iconSet: 'duo',
        roles: ['auction'],
        routerLink: ['auction', 'vehicle-selection'],
      },
      {
        label: 'Registrar Compradores',
        icon: faUserCirclePlus,
        iconSet: 'duo',
        roles: ['auction'],
        routerLink: ['auction', 'register-buyers'],
      },
      {
        label: 'Registrar Ofertas',
        icon: faMessageDollar,
        iconSet: 'duo',
        roles: ['auction'],
        routerLink: ['auction', 'register-offers'],
      },
      {
        label: 'Cerrar Remate',
        icon: faGavel,
        iconSet: 'duo',
        roles: ['auction'],
        routerLink: ['auction', 'close-auction'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'close-auction',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Cerrar Remate',
      roles: ['auction'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./close-auction/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./close-auction/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model.extNumber || data.model.number}` },
        },
      },
    ],
  },
  {
    path: 'register-offers',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Ofertas',
      roles: ['auction'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./register-offers/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./register-offers/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model.extNumber || data.model.number}` },
        },
      },
    ],
  },
  {
    path: 'register-buyers',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Registrar Compradores',
      roles: ['auction'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./register-buyers/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./register-buyers/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model.extNumber || data.model.number}` },
        },
      },
    ],
  },
  {
    path: 'vehicle-selection',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Seleccionar Vehículos',
      roles: ['auction'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./vehicle-selection/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./vehicle-selection/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model.number || 'Nuevo'}` },
        },
      },
    ],
  },
];
